export default {
  styleOverrides: {
    root: {
      color: 'var(--color-text-secondary)',
      transition: 'color 0.15s ease',

      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },

      '&.Mui-checked': {
        color: 'var(--color-primary)',

        '&:hover': {
          backgroundColor: 'rgba(37, 99, 235, 0.04)',
        },
      },

      '&.Mui-disabled': {
        color: 'var(--color-text-disabled)',
      },
    },
  },
};
